<template>
  <div>
    <QCard class="my-card">
      <QCardSection class="bg-primary text-white">
        <div class="text-h6">CLI</div>
      </QCardSection>
      <QSeparator dark />
      <QCardSection>
        For a guide and recipes on how to configure / customize this project,
        <br />check out the
      </QCardSection>
      <QSeparator dark />
      <QCardActions class="bg-primary text-white">
        <QBtn type="a" target="_blank" href="https://cli.vuejs.org" color="secondary">Doc</QBtn>
      </QCardActions>
    </QCard>
    <QCard class="my-card">
      <QCardSection class="bg-primary text-white">
        <div class="text-h6">VueJS resources</div>
      </QCardSection>
      <QSeparator dark />
      <QCardSection>Resources on vue js</QCardSection>
      <QSeparator dark />
      <QCardActions class="bg-primary text-white">
        <QBtnGroup>
          <QBtn type="a" target="_blank" href="https://vuejs.org" color="secondary">Doc</QBtn>
          <QBtn type="a" target="_blank" href="https://forum.vuejs.org" color="secondary">Forum</QBtn>
          <QBtn type="a" target="_blank" href="https://chat.vuejs.org" color="secondary">Chat</QBtn>
          <QBtn type="a" target="_blank" href="https://twitter.com/vuejs" color="secondary">Twitter</QBtn>
          <QBtn type="a" target="_blank" href="https://news.vuejs.org" color="secondary">News</QBtn>
        </QBtnGroup>
      </QCardActions>
    </QCard>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import {
  QPage,
  QCard,
  QCardSection,
  QCardActions,
  QBtnGroup,
  QBtn,
  QSeparator,
  QIcon
} from "quasar";

@Component({
  components: {
    QPage,
    QCard,
    QCardSection,
    QCardActions,
    QBtnGroup,
    QBtn,
    QSeparator,
    QIcon
  }
})
export default class VueJs extends Vue {}
</script>

<style lang="sass" scoped>
.my-card
  display: inline-block
  margin: 0.5em
</style>
